export const dataURLtoFile = async (dataurl: string) => {
  return await fetch(dataurl)
    .then((res) => res.blob())
    .then((blob) => new File([blob], "File name", { type: "image/png" }));
};
